import * as React from 'react';
const MapIconCircle = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1.2em'}
    height={'1.2em'}
    viewBox={'0 0 19 19'}
    fill='none'
    {...props}
  >
    <circle cx='9.5' cy='9.5' r='9.5' fill='#D9D9D9' />
    <path
      transform={'translate(3, 3)'}
      d='M6.49999 0C3.90393 0 1.79189 2.11204 1.79189 4.70808C1.79189 7.92985 6.00518 12.6596 6.18457 12.8594C6.35306 13.047 6.64723 13.0467 6.81542 12.8594C6.99481 12.6596 11.2081 7.92985 11.2081 4.70808C11.208 2.11204 9.09603 0 6.49999 0ZM6.49999 7.07685C5.19385 7.07685 4.13125 6.01423 4.13125 4.70808C4.13125 3.40194 5.19387 2.33934 6.49999 2.33934C7.80611 2.33934 8.86871 3.40196 8.86871 4.70811C8.86871 6.01425 7.80611 7.07685 6.49999 7.07685Z'
      fill='currentColor'
    />
  </svg>
);
export default MapIconCircle;
